<template>
    <div data-testid="admin-filter" class="admin-filter">
        <h3>{{ $t('search.filters.admin.title') }}</h3>
        <div v-for="filter in availableSearchFilters?.adminFilters?.filters" :key="filter.key">
            <VJoyCheckbox :checked="isChecked(filter.key)" :data-testid="`admin-filter-${filter.key}`" @update:checked="toggleFilter(filter.key)">
                {{ filter.label }} ({{ filter.count }})
            </VJoyCheckbox>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import {RetrieveAvailableFiltersAdminFilterEnum} from '@api';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    function isAdminFilter(filterKey: string): filterKey is RetrieveAvailableFiltersAdminFilterEnum {
        return Object.values(RetrieveAvailableFiltersAdminFilterEnum).some((filter) => filter === filterKey);
    }

    function isChecked(filterKey: string) {
        if (!isAdminFilter(filterKey)) {
            return false;
        }

        return filtersStore.isAdminFilterChecked(filterKey);
    }

    function toggleFilter(filterKey: string) {
        if (!isAdminFilter(filterKey)) {
            return;
        }

        filtersStore.toggleAdminFilter(filterKey);
    }
</script>

<style lang="scss" scoped>
    .admin-filter {
        background-color: var(--joy-color-quaternary-10);
    }
</style>
